/**
 * Created by robincoburn on 23/09/15.
 */
angular.module('qkr').directive('couponQr', () => ({

        restrict: 'E',
        scope: {
            qrUrl: '=',
            name: '='
        },
        template: require('../../coupons/templates/couponQr.html')
    }));



// WEBPACK FOOTER //
// ./src/coupons/directives/couponQr.js